import React from 'react';
import { autobind } from 'core-decorators';
import { UncontrolledTooltip } from 'reactstrap';

@autobind
class Tooltip extends React.Component {
  render() {
    let { text, placement, children, id } = this.props;

    return (
      <span>
        {children}
        <UncontrolledTooltip placement={placement} target={id}>
          {text}
        </UncontrolledTooltip>
      </span>
    );
  }
}

export default Tooltip;
